import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { INPUT_SIZES, FormField, FormHelp, Label } from '@zillow/constellation';
import uniqueId_1 from '../../node_modules/lodash/uniqueId.js';
import jsxRuntime from '../../node_modules/react/jsx-runtime.js';

var _excluded = ["InputComponent", "className", "error", "renderLabel", "children", "required", "id", "testId", "description"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var LabeledInput = function LabeledInput(_ref) {
  var InputComponent = _ref.InputComponent,
    className = _ref.className,
    error = _ref.error,
    renderLabel = _ref.renderLabel,
    children = _ref.children,
    required = _ref.required,
    id = _ref.id,
    testId = _ref.testId,
    description = _ref.description,
    props = _objectWithoutProperties(_ref, _excluded);
  // ToggleButtonGroup / ButtonGroup is not considered a form element by Constellation and thus
  // doesn't have aria-labelledby wired up automatically by Constellation, so we explicitly
  // construct it and provide it to renderLabel / control.
  var labelID = useMemo(function () {
    return uniqueId_1('label_');
  }, []);
  return /*#__PURE__*/jsxRuntime.jsx(FormField, {
    "data-test-id": testId,
    className: className,
    required: required,
    controlId: id !== null && id !== void 0 ? id : props.name,
    label: renderLabel({
      id: labelID,
      children: children
    }),
    control: /*#__PURE__*/jsxRuntime.jsx(InputComponent, _objectSpread({
      error: error,
      "aria-labelledby": labelID
    }, props)),
    description: error && /*#__PURE__*/jsxRuntime.jsx(FormHelp, {
      error: true,
      children: error.message
    }) || description
  });
};
LabeledInput.SimpleLabel = function (props) {
  return /*#__PURE__*/jsxRuntime.jsx(Label, _objectSpread({}, props));
};
LabeledInput.SimpleLabel.propTypes = {
  children: PropTypes.node.isRequired
};
LabeledInput.propTypes = {
  InputComponent: PropTypes.elementType,
  renderLabel: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  description: PropTypes.node,
  label: PropTypes.node,
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  required: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  testId: PropTypes.string
};
LabeledInput.defaultProps = {
  renderLabel: LabeledInput.SimpleLabel,
  size: INPUT_SIZES.lg
};
var withLabel = function withLabel(InputComponent) {
  return function (props) {
    return /*#__PURE__*/jsxRuntime.jsx(LabeledInput, _objectSpread({
      InputComponent: InputComponent
    }, props));
  };
};
var withLabel$1 = withLabel;

export { LabeledInput, withLabel$1 as default };
//# sourceMappingURL=withLabel.js.map
